export default "__VITE_ASSET__AJ97cNky__"